const switchLanguage = () => {
    if (document.getElementById('pingunautlanguageswitcher')) {
        const button = document.getElementById('pingunautlanguageswitcher');
        document.addEventListener('click', ev => {
            if (!ev.target.matches('#pingunautlanguageswitcher')) return;
            ev.preventDefault();
            const hidden = document.querySelector('.pingunaut-languages-hidden');
            hidden.classList.toggle('pingunaut-languages-hidden__show');

        });
    }
}
export default switchLanguage;